import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['value', 'icon']

    connect() {
        this.keyIsVisible = false
        this.secretValue = this.element.dataset.secretKeyValue
    }

    toggleVisibility() {
        this.keyIsVisible = !this.keyIsVisible

        if (this.keyIsVisible) {
            this.valueTarget.textContent = this.secretValue
            this.iconTarget.classList.remove('fa-eye')
            this.iconTarget.classList.add('fa-eye-slash')
        } else {
            this.valueTarget.textContent = '•••••••••••••••••••••••••'
            this.iconTarget.classList.remove('fa-eye-slash')
            this.iconTarget.classList.add('fa-eye')
        }
    }
}
